export default __webpack_public_path__ + "static/media/badges_placeholder.4aea0a26.png";